import React, { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import Layout from "@/components/Layout";
import Logo from "@/components/Logo";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { useAuth } from "@/lib/auth";
import { toast } from "sonner";
import GoogleG from "@/components/GoogleG";

export default function Login() {
  const { login } = useAuth();
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      await login(email, password);
      toast.success("Bienvenue !");
      navigate("/dashboard");
    } catch (err) {
      toast.error(err.response?.data?.detail || "Erreur de connexion");
    } finally { setLoading(false); }
  };

  const googleLogin = () => {
    // REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
    const redirectUrl = window.location.origin + "/dashboard";
    window.location.href = `https://auth.emergentagent.com/?redirect=${encodeURIComponent(redirectUrl)}`;
  };

  return (
    <Layout>
      <div className="max-w-md mx-auto px-4 py-16">
        <div className="flex justify-center mb-8"><Logo size={56} /></div>
        <div className="bg-white rounded-3xl p-8 border border-rose-100 shadow-[0_8px_30px_rgba(244,63,94,0.08)]">
          <h1 className="font-display text-2xl font-black text-stone-800 text-center" data-testid="login-title">Bon retour parmi nous</h1>
          <p className="text-stone-500 text-center mt-1 text-sm">Connectez-vous pour retrouver vos doudous</p>

          <Button onClick={googleLogin} variant="outline" className="w-full mt-6 rounded-full py-6 border-2 border-stone-200 hover:bg-stone-50 font-bold" data-testid="login-google-button">
            <GoogleG size={20} className="mr-2" /> Continuer avec Google
          </Button>

          <div className="my-6 flex items-center gap-3">
            <div className="h-px bg-rose-100 flex-1" />
            <span className="text-xs text-stone-400 font-bold uppercase tracking-widest">ou</span>
            <div className="h-px bg-rose-100 flex-1" />
          </div>

          <form onSubmit={handleSubmit} className="space-y-4">
            <div>
              <Label htmlFor="email">Email</Label>
              <Input id="email" type="email" required value={email} onChange={(e) => setEmail(e.target.value)} placeholder="parent@famille.fr" className="rounded-2xl mt-1 py-6" data-testid="login-email-input" />
            </div>
            <div>
              <div className="flex items-center justify-between">
                <Label htmlFor="password">Mot de passe</Label>
                <Link to="/mot-de-passe-oublie" className="text-xs text-orange-600 hover:underline font-bold" data-testid="login-forgot-password-link">Mot de passe oublié ?</Link>
              </div>
              <Input id="password" type="password" required value={password} onChange={(e) => setPassword(e.target.value)} className="rounded-2xl mt-1 py-6" data-testid="login-password-input" />
            </div>
            <Button type="submit" disabled={loading} className="w-full bg-orange-500 hover:bg-orange-600 rounded-full py-6 font-bold shadow-lg shadow-orange-500/30" data-testid="login-submit-button">
              {loading ? "Connexion..." : "Se connecter"}
            </Button>
          </form>

          <p className="text-center text-sm text-stone-500 mt-6">
            Pas encore de compte ? <Link to="/inscription" className="text-orange-600 font-bold" data-testid="login-signup-link">Créer un compte</Link>
          </p>
        </div>
      </div>
    </Layout>
  );
}
